import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import FinanceAssetCodeService from "services/Setup/Master/financeAssetCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  financeAssetCodeList: {},
};

export const getFinanceAssetCodeList = createAsyncThunk(
  "financeAssetCode/getFinanceAssetCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await FinanceAssetCodeService.getFinanceAssetCodeList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const financeAssetCode = createSlice({
  name: "financeAssetCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get financeAsset code list
      .addCase(getFinanceAssetCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getFinanceAssetCodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.financeAssetCodeList = action.payload;
      })
      .addCase(getFinanceAssetCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  financeAssetCode.actions;

export default financeAssetCode.reducer;
